module.exports = __webpack_public_path__ + "static/media/concursoInnovacion.f3cb59b2.png";